import React, {Fragment, useEffect, useState} from "react";
import Loading from "../components/Loading";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import UserService from "../services/UserService";
import {MongoChart} from "../components/MongoChart";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import 'react-data-grid/lib/styles.css';

export const Insights = () => {
    const {user, getAccessTokenSilently} = useAuth0();

    const [state, setState] = useState({
        showResult: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
        response: undefined
    });

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            console.log('User being fetched is' + user.sub);
            UserService.userSettingsFlow(token, user).then(
                response => {
                    console.log(response);
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data,
                        response: response.data
                    });
                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };

    // effect runs on component mount
    useEffect(() => {
        callApi().then();
    }, []);

    const charts = [
        {
            title: 'Special Equipment',
            chartId: '65c14264-8c9d-4c6c-84e5-691933a4bbb0'
        },
        {
            title: 'Equipment by Lane Rate',
            chartId: '65c14322-858f-40cb-88c8-b38f9ac4fce1'
        },
        {
            title: 'Covid Impact',
            chartId: '65c143af-4433-46f3-8add-a7487b4cf24b'
        },
        {
            title: 'Rolling 90 Days',
            chartId: '65c1372e-8c9d-4842-86c5-69193398b5e7'
        },
        {
            title: 'The Big Three',
            chartId: '43df74e5-1e80-4c1e-9e0c-8148136312c7'
        },
        {
            title: '2025 by %',
            chartId: '844a5f68-223c-4fb6-87f9-d8db72b002db'
        },
        {
            title: 'Year in Words',
            chartId: 'f30d010e-0c79-4890-821d-8af94e31939b'
        }
    ];

    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <Fragment>
            {state.showResult && (
                <div className="insights-container">
                    <Tabs selectedIndex={selectedTab} onSelect={(index) => setSelectedTab(index)}>
                        <TabList className="profile-child-tabs insights-tab-list">
                            {charts.map(chart => (
                                <Tab key={chart.chartId}>
                                    <span>{chart.title}</span>
                                </Tab>
                            ))}
                        </TabList>

                        {charts.map(chart => (
                            <TabPanel key={chart.chartId}>
                                <div className="panel-content">
                                    <MongoChart
                                        height={'600px'}
                                        width={'100'}
                                        chartId={chart.chartId}
                                    />
                                </div>
                            </TabPanel>
                        ))}
                    </Tabs>
                </div>
            )}
        </Fragment>
    );
};

export default withAuthenticationRequired(Insights, {
    onRedirecting: () => <Loading/>,
});
